/**
 * Date Picker Widget for RUL Forms
 */

import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import type { DatePickerWidget } from '@/api/types/rul.types';

interface DatePickerWidgetProps {
  widget: DatePickerWidget;
  onChange: (name: string, value: any) => void;
  error?: string;
}

export const DatePickerWidgetComponent: React.FC<DatePickerWidgetProps> = ({
  widget,
  onChange,
  error,
}) => {
  if (!widget.visible) return null;

  const value = widget.value ? dayjs(widget.value) : null;
  const minDate = widget.min_date ? dayjs(widget.min_date) : undefined;
  const maxDate = widget.max_date ? dayjs(widget.max_date) : undefined;

  return (
    <div className="rul-field">
      {widget.label && (
        <label className="rul-field-label">
          {widget.label}
          {widget.required && <span className="rul-field-required">*</span>}
        </label>
      )}
      <DatePicker
        value={value}
        placeholder={widget.placeholder}
        disabled={!widget.enabled}
        status={error ? 'error' : undefined}
        format={widget.format || 'YYYY-MM-DD'}
        minDate={minDate}
        maxDate={maxDate}
        style={{ width: '100%' }}
        onChange={(date) =>
          onChange(widget.name, date ? date.format('YYYY-MM-DD') : null)
        }
      />
      {widget.help_text && !error && (
        <div className="rul-field-help">{widget.help_text}</div>
      )}
      {error && <div className="rul-field-error">{error}</div>}
    </div>
  );
};
